// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollToTop_wrapper__ycERp","wrapper2":"ScrollToTop_wrapper2__nD6-G","arrow":"ScrollToTop_arrow__RudkB"};